const Otros = {
  otros: [
    {
      id: 1,
      path:"/productos-otros",
      cover: "./images/otros/1-llavero.jpg",
      cover1:  "./images/otros/1-llavero.jpg",
      cover2:  "./images/otros/1-llavero.jpg",
      name: "Llavero de madera",
      description: "Este reloj de pared es un accesorio moderno y minimalista con bordes negros, hecho de plástico duro, resistente a golpes y caídas. Los números de tamaño normal son fáciles de leer, y funciona con una pila doble A. Fácil de instalar con su soporte para colgar, y su tamaño de 200x200mm lo hace perfecto para cualquier pared estándar. Un producto elegante y funcional para decorar cualquier ambiente.",
      price: "LL1",
      discount: "2",
    },
   
  ],
}
export default Otros
